module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "AddComms"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": "Communication log - Add entry",
      "large": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "commsForm"
    }
  }, [_c('alert', {
    attrs: {
      "show": _vm.showError,
      "type": "danger"
    },
    on: {
      "update:show": function($event) {
        _vm.showError = $event
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorString))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("To")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comms.to),
      expression: "comms.to"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "to"
    },
    domProps: {
      "value": (_vm.comms.to)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.comms, "to", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("From")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comms.fromm),
      expression: "comms.fromm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "fromm"
    },
    domProps: {
      "value": (_vm.comms.fromm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.comms, "fromm", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Type")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comms.log_type),
      expression: "comms.log_type"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.comms, "log_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "file_note"
    }
  }, [_vm._v("File Note")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "mail"
    }
  }, [_vm._v("Mail")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "person"
    }
  }, [_vm._v("Person")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Subject/Description")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comms.subject),
      expression: "comms.subject"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "type": "text",
      "name": "subject"
    },
    domProps: {
      "value": (_vm.comms.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.comms, "subject", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Text")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comms.text),
      expression: "comms.text"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "name": "text"
    },
    domProps: {
      "value": (_vm.comms.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.comms, "text", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Attachments")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_vm._l((_vm.files), function(f, i) {
    return [_c('div', {
      class: 'row top-buffer file-row-' + i
    }, [_c('div', {
      staticClass: "col-sm-4"
    }, [(f.file == null) ? _c('span', {
      staticClass: "btn btn-info btn-file pull-left"
    }, [_vm._v("\n                                                    Atttach File "), _c('input', {
      class: 'file-upload-' + i,
      attrs: {
        "type": "file",
        "name": 'file-upload-' + i
      },
      on: {
        "change": function($event) {
          return _vm.uploadFile('file-upload-' + i, f)
        }
      }
    })]) : _c('span', {
      staticClass: "btn btn-info btn-file pull-left"
    }, [_vm._v("\n                                                    Update File "), _c('input', {
      class: 'file-upload-' + i,
      attrs: {
        "type": "file",
        "name": 'file-upload-' + i
      },
      on: {
        "change": function($event) {
          return _vm.uploadFile('file-upload-' + i, f)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4"
    }, [_c('span', [_vm._v(_vm._s(f.name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeFile(i)
        }
      }
    }, [_vm._v("Remove")])])])]
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.attachAnother($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-plus top-buffer-2x"
  })])], 2)])])])], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.addingComms) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": ""
    },
    on: {
      "click": _vm.ok
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Adding")]) : _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-525e2716"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/add_comm_log.vue
// module id = 976
// module chunks = 0